import { render, staticRenderFns } from "./Hue.vue?vue&type=template&id=b67bc132"
import script from "./Hue.vue?vue&type=script&lang=js"
export * from "./Hue.vue?vue&type=script&lang=js"
import style0 from "./Hue.vue?vue&type=style&index=0&id=b67bc132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports